














































import Vue from "vue";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

const DISMISS_STORAGE_KEY = "proBannerDismissed";

export default Vue.extend({
    name: "ProBanner",

    data: function() {
        return {
            bannerVisible: localStorage.getItem(DISMISS_STORAGE_KEY) !== "true",
        };
    },

    computed: {
        proUrl: function(): string {
            return process.env.VUE_APP_PRO + "/" + Trans.currentLocale;
        },
    },

    methods: {
        dismiss: function(): void {
            this.bannerVisible = false;
            localStorage.setItem(DISMISS_STORAGE_KEY, "true");
        },
    },
});
